"use client";

import React from "react";
import Image from "next/image";
import "./GalleryGrid.css";
import { motion } from "framer-motion";

export default function GalleryGrid({ images = [] }) {
  if (!images?.length) return null;

  const sampleImages = images.filter((img) =>
    img?.title?.toLowerCase()?.includes("sample"),
  );

  const galleryImages = images.filter(
    (img) =>
      img?.type?.toLowerCase() === "gallery" &&
      !img?.title?.toLowerCase()?.includes("sample"),
  );

  const mixedImages = [];

  const maxLength = Math.max(sampleImages.length, galleryImages.length);

  for (let i = 0; i < maxLength; i++) {
    if (sampleImages[i]) {
      mixedImages.push(sampleImages[i]);
    }

    if (galleryImages[i]) {
      mixedImages.push(galleryImages[i]);
    }
  }

  const visibleImages = mixedImages.slice(0, Math.min(mixedImages.length, 8));
  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  const layoutMap = [
    "hero-wide", // 1
    "portrait", // 2

    "square", // 3
    "square", // 4
    "tall", // 5

    "wide", // 6
    "small-portrait", // 7

    "full", // 8
  ];

  const sizeMap = {
    "hero-wide": {
      w: 1168,
      h: 568,
    },

    portrait: {
      w: 568,
      h: 568,
    },

    square: {
      w: 570,
      h: 570,
    },

    tall: {
      w: 568,
      h: 568,
    },

    wide: {
      w: 1168,
      h: 568,
    },

    "small-portrait": {
      w: 568,
      h: 454,
    },

    full: {
      w: 1760,
      h: 940,
    },
  };

  const getImageUrl = (url, w, h) => {
    if (!url) return "";

    const separator = url.includes("?") ? "&" : "?";

    return `${url}${separator}w=${w}&h=${h}&q=100`;
  };

  return (
    <section className="gallery-grid-section section-padding">
      <div className="main-container-fluid">
        <div className="inner-flex inner-flex-center inner-flex-medium">
          <div className="section-title">
            <h2 className="white-color">Gallery</h2>
          </div>

          <div className="gallery-grid">
            {visibleImages.map((img, index) => {
              const type = layoutMap[index] || "square";

              const size = sizeMap[type];

              return (
                <motion.a
                  key={index}
                  href={img.image_full}
                  data-fancybox="galleryImages"
                  className={`gallery-item ${type}`}
                  initial={{
                    opacity: 0,
                    scale: 0.95,
                  }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                  }}
                  transition={{
                    duration: 0.8,
                    ease: "easeOut",
                    delay: index * 0.08,
                  }}
                  viewport={{
                    once: true,
                    amount: 0.2,
                  }}
                >
                  <div className="gallery-image-wrap">
                    <Image
                      fill
                      priority={index < 2}
                      quality={100}
                      alt={img.title || `gallery-${index}`}
                      src={getImageUrl(img.image, size.w, size.h)}
                      className="gallery-image"
                      sizes={`
                        (max-width:768px) 100vw,
                        ${size.w}px
                      `}
                    />

                    <div className="gallery-overlay">
                      <div className="gallery-view-btn">
                        <span>View</span>
                      </div>
                    </div>
                  </div>
                </motion.a>
              );
            })}

            {/* Hidden images for fancybox loop */}

            {mixedImages.slice(visibleImages.length).map((img, index) => (
              <a
                key={`hidden-${index}`}
                href={img.image_full}
                data-fancybox="galleryImages"
                style={{
                  display: "none",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
